import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate,useParams } from 'react-router-dom';

import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

export default function FacultyEdit() {

  const [message, setMessage] = useState(false);
  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);

  const { http } = Api();
  let { id } = useParams();
  const decodedID = atob(id);
  sessionStorage.setItem("id", decodedID);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({ dcode: '', dname: '',fid: '',dstatus: ''}); //20/3/2024 for validation

  useEffect(() => {
      const { http } = Api();
      const id1 = sessionStorage.getItem("id");

      const fetchData = async () => {
          try {

              const response = await http.get(`/Admin/getdiscipline/${id1}`);
              const response1 = await http.get(`/Admin/getfaculty`);
              console.log(response1);
              setDisciplineData(response.data.discipline);
              setFacultyData(response1.data.data);

          } catch (error) {
              
              setMessage("somthing went wrong");
              console.error('Error fetching discipline data:', error);

          }
      };

      fetchData();

  }, []);


  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }

  const validateForm = () => {

    
    const updatedErrors = {};
    let hasError = false;

    const faculty_id = document.getElementById('faculty_id').value;
    const displinecode = document.getElementById('disciplinecode').value;
    const displinename = document.getElementById('disciplinename').value;
    const disstatus = document.getElementById('status').value;

    if (!faculty_id || faculty_id == "0") {

      updatedErrors.fid = 'Please enter a select Faculty';
      hasError = true;     

    }
    if (!displinecode) {

      updatedErrors.dcode = 'Please enter a Displine code';
      hasError = true;   

    }
    if (!displinename) {
      updatedErrors.dname = 'Please enter a Displine name';
      hasError = true; 

    }
    if (disstatus === "0") {
      updatedErrors.dstatus = 'Please select a Status';
      hasError = true; 

    }
    if (hasError) 
    {
      setErrors(updatedErrors);
      if (!faculty_id) {
          document.getElementById('faculty_id').focus();
      } else if (!displinecode) {
          document.getElementById('displinecode').focus();
      } else if (!displinename) {
        document.getElementById('displinename').focus();
      }
      return false;
   } else {
      setErrors({ dcode: '', dname: '',fid: '',dstatus: '' });
      return true;
   }
  };



  const cancelForm = () => {
      navigate("/admin/discipline");
  };

  const saveForm = () => {


      if (validateForm()) {

          const id2 = sessionStorage.getItem("id");
          


          const disciplinecode = document.getElementById('disciplinecode').value;
          const disciplinename = document.getElementById('disciplinename').value;
          const faculty_id = document.getElementById('faculty_id').value;
          const remarks = document.getElementById('remarks').value;
          const status = document.getElementById('status').value;

          const remarksValue = remarks ? remarks : "Null";
        
          http.post(`/Admin/updatediscipline/${id2}`, { faculty_id:faculty_id, discipline_code: disciplinecode, discipline_name: disciplinename, remarks: remarksValue, status: status })
              .then(response => {
                console.log(response.data);
                  if (response.data.status_code === "MSG2") {
                      sessionStorage.setItem("message", "Discipline updated successfully");
                      navigate("/admin/discipline");

                  }
              })
              .catch(error => {
                  console.error(error);


                  if (error.response && error.response.status === 500) {
                      setMessage("Duplicate Value: This faculty already exists");
                  } else {
                      setMessage("Something Went Wrong");
                  }

              });
      }
  };


  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12" >
              <div className="card">                
                <div className="col-md-12">
                  <div className="card-header"> 
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Edit Discipline</h5>
                    </div>
                  </div>
                  <div className="card-body">
                  {message && (
                                                <div className="alert alert-danger mar2" role="alert">
                                                    <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                                                </div>
                                            )}
                    <div className="card-body pdg">
                      <div className="table-responsive">


                        <div className="form theme-form">
                          <div className="card-body custom-input">
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Discipline Code <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <input type="text" className="form-control" id="disciplinecode" name="disciplinecode" placeholder="Discipline Code" defaultValue={discipline.discipline_code} required ></input>
                                  {errors.dcode && <p className="text-danger">{errors.dcode}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Discipline Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <input type="text" className="form-control" id="disciplinename" name="disciplinename" placeholder="Discipline Name" defaultValue={discipline.discipline_name} required ></input>
                                  {errors.dname && <p className="text-danger">{errors.dname}</p>}
                                  </div>
                                </div>

                                <div className="mb-3 row">
                                  <label className="col-sm-3">Select Faculty Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                  <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" required>
                                        <option value="" >Select Faculty</option>

                                        {faculty.map(facultys => (

                                            <option value={facultys.id} selected={discipline.faculty_id === facultys.id ? 'selected' : null}>{facultys.faculty_name}</option>
                                        ))}

                                    </select>
                                    {errors.fid && <p className="text-danger">{errors.fid}</p>}

                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Remarks</label>
                                  <div className="col-sm-9">
                                    <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" defaultValue={discipline.remarks === 'Null' ? '' : discipline.remarks} required></textarea>
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Status <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                    <select className="form-control input-air-primary" id="status" name="status" required defaultValue={discipline.status}>
                                        <option value="0">---Select---</option>
                                        <option value="active" selected={discipline.status === 'active' ? 'selected' : null}>Active</option>
                                        <option value="inactive" selected={discipline.status === 'inactive' ? 'selected' : null}>Inactive</option>
                                    </select>
                                    {errors.dstatus && <p className="text-danger">{errors.dstatus}</p>}

                                </div>
                            </div>

                              </div>
                            </div>
                          </div>
                          
                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>
                          
                        </div>



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
